module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"pvTitle":"Photovoltaik-Potenzial","reloadLabel":"Dachflächen neu abfragen","pendingMessage":"Daten werden abgefragt...","lastUpdateLabel":"Quelle: Bundesamt für Energie (BFE). Aktualisiert am"}}')
  delete Component.options._Ctor
}
